import { LocalizedString } from "./localizedString";

export interface EventRewardDto {
  eventId: number;
  eventRewardId: number;
  eventTitle: LocalizedString;
  eventRewardGroupTitle: LocalizedString | null;
  eventRewardTitle: LocalizedString | null;
  primaryLanguage: string;
  languages: string[];
  eventWinningMessage: LocalizedString | null;
}

export class EventReward {
  eventId: number;
  rewardId: number;
  eventTitle: LocalizedString;
  rewardGroupTitle: LocalizedString | null;
  rewardTitle: LocalizedString | null;
  primaryLanguage: string;
  languages: string[];
  winningMessage: LocalizedString | null;

  constructor(dto: EventRewardDto) {
    this.eventId = dto.eventId;
    this.rewardId = dto.eventRewardId;
    this.eventTitle = dto.eventTitle;
    this.rewardGroupTitle = dto.eventRewardGroupTitle;
    this.rewardTitle = dto.eventRewardTitle;
    this.primaryLanguage = dto.primaryLanguage;
    this.languages = dto.languages;
    this.winningMessage = dto.eventWinningMessage;
  }
}
